import { useCallback } from "react";
import { ConnectProto } from "@racoon/api";
import { Namespace, useT } from "@racoon/i18n";
import { getEnumName } from "@racoon/lib";

import type { SiteJob } from "./site-pins";

/** A job's status as the map card and site panel name it. */
export function useJobLabel() {
  const t = useT();
  return useCallback(
    ({ job }: Pick<SiteJob, "job">) => {
      const name = getEnumName(ConnectProto.JobStatusSchema, job.status);
      return name ? t(Namespace.Enum, name) : "";
    },
    [t],
  );
}
